import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/pages/index/slider/banner01.jpg")